<script lang="ts">
  import { ErrorPage } from '@glimja/storefront/pages';
</script>

<ErrorPage />
